export const EInputType = {
	TEXT: 'TEXT',
	NUMBER: 'NUMBER',
	SELECT: 'SELECT',
	AMOUNT: 'AMOUNT',
	DATE: 'DATE',
	CHECKBOX: 'CHECKBOX',
	BUTTON_ICON: 'BUTTON_ICON',
};

/**
 * @typedef {Object} TRenderProps
 * @property {TBodyData} dataCell
 * @property {TBody} dataRow
 */

/**
 * @typedef {Object} TOnchange
 * @property {Object} event
 * @property {TBody} rowData
 * @property {string} cellKey
 */

/**
 * @typedef {Object} TValidations
 * @property {Function} [onChange]
 */

/**
 * @typedef {Object} THeadersData
 * @property {string} key
 * @property {string} label
 * @property {Array} [options]
 * @property {string} [inputType]
 * @property {TValidations} [validations]
 * @property {boolean} [hideColumn]
 * @property {number} [width]
 * @property {string} [prefix]
 * @property {string} [suffix]
 * @property {function(TRenderProps): React.ReactElement} [render]
 */

/**
 * @typedef {Object} TActions
 * @property {string} label
 * @property {React.ReactElement} icon
 * @property {function(TBody): void} onClick
 */

/**
 * @typedef {Object} TBodyData
 * @property {string} key
 * @property {boolean} [disabled]
 * @property {string|number} value
 * @property {string} [inputType]
 * @property {Object} [validations]
 */

/**
 * @typedef {Object} TBody
 * @property {TBodyData[]} data
 * @property {string} idRow
 * @property {boolean} [isNewRow]
 * @property {boolean} [isUpdatedRow]
 * @property {boolean} [isDeletedRow]
 */

/**
 * @typedef {Object} TableDataProps
 * @property {THeadersData[]} headers
 * @property {TBody[]} body
 * @property {string} tableName
 * @property {boolean} [disablePageButton]
 */

/**
 * @typedef {Object} TInputTypeComponentProps
 * @property {string} rowIndex
 * @property {TBody} rowData
 * @property {string} [inputTypeToUse]
 * @property {Object} [validations]
 * @property {string} name
 * @property {Array} options
 * @property {string|number} [value]
 * @property {boolean} [disabled]
 * @property {number} [decimalNumber]
 * @property {string} [prefix]
 * @property {string} [suffix]
 */

/**
 * @typedef {Object} TUseTableData
 * @property {TBody[]} bodyTableData
 * @property {string} tableName
 * @property {number} [decimalNumber]
 */
